export default "__VITE_ASSET__636c1cfc__"